<template>
  <b-row>
    <b-col sm="12" md="6" lg="6">
      <b-form-group label="Destino">
        <b-form-select
          value="Seleccione..."
          :options="client_options"
          :state="$v.form.client.$dirty ? !$v.form.client.$error : null"
          v-model="$v.form.client.$model"
        >
        </b-form-select>
      </b-form-group>
      <b-form-group>
        <label for="name">Nombre del Chofer</label>
        <b-form-input
          type="text"
          id="name"
          :state="$v.form.truck_driver.$dirty ? !$v.form.truck_driver.$error : null"
          v-model="$v.form.truck_driver.$model"
          placeholder="ej. Juan Soto"
        ></b-form-input>
      </b-form-group>

      <b-form-group>
        <label for="name">Patente</label>
        <b-form-input
          type="text"
          id="name"
          :state="$v.form.license_plate.$dirty ? !$v.form.license_plate.$error : null"
          v-model="$v.form.license_plate.$model"
          placeholder="ej. FL9090"
        ></b-form-input>
      </b-form-group>
      <b-form-group>
        <label for="textarea-auto-height">Notas:</label>
        <b-form-textarea
          id="textarea"
          v-model="form.note"
          placeholder="Escriba acá notas relacionadas con la guia de despacho."
          rows="3"
          max-rows="6"
        >
        </b-form-textarea>
      </b-form-group>
    </b-col>
    <b-col sm="12" md="6" lg="6">
      <b-form-group label="Número">
        <b-form-input
          type="text"
          id="name"
          :state="$v.form.number.$dirty ? !$v.form.number.$error : null"
          v-model="$v.form.number.$model"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="Fecha de guía de despacho">
        <b-form-datepicker
          placeholder="dd-mm-aaaa"
          locale="es"
          id="waybill_date"
          :state="$v.form.waybill_date.$dirty ? !$v.form.waybill_date.$error : null"
          v-model="$v.form.waybill_date.$model"
        ></b-form-datepicker>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import V2Select from "@/views/reusable/V2Select";
export default {
  props: ["form"],
  components: {
    V2Select
  },
  data() {
    return {
      client_options: [],
      company_options: []
    };
  },
  validations: {
    form: {
      client: { required },
      number: { required },
      waybill_date: { required },
      license_plate: { required },
      truck_driver: { required },
      note: {}
    }
  },
  created() {
    this.getClients();
  },
  methods: {
    getClients() {
      this.$axios
        .get("/production/get_clients/")
        .then((res) => {
          const data = res.data.data;
          const customers = [];
          for (let key in data) {
            const customer = data[key];
            customers.push(customer);
          }
          this.client_options = customers;
        })
        .catch((error) => console.log(error));
    }
  }
};
</script>

<style></style>
